import {
  FunctionalComponent, SVGAttributes,
} from 'vue';
import {
  RouteMap,
} from 'vue-router';

import {
  components,
} from '@/generated/qmulus/openapi.ts';

export enum EAppGroupSemantic {
  SALES = 'SALES',
  DEVELOPMENT = 'DEVELOPMENT',
  CONFIGURATION = 'CONFIGURATION',
}

export type TAppDetails = {
  icon: string | FunctionalComponent<SVGAttributes, any, any>,
  route: keyof RouteMap,
};

export type TSemanticAppGroupIds = components['schemas']['QmulusOperationSemanticAppGroup']['appIds'][number];
